import React, { memo } from "react";
import PropTypes from "prop-types";

import { handleLink } from "widgets/others";

import styles from "./style.css";
function TextComponent({
  value,
  style = {},
  onDoubleClick = () => {},
  isFocused = false
}) {
  let xssChecker = handleLink(value);
  return xssChecker ? (
    <div
      className={`${styles.text} ${styles.link}`}
      style={style}
      onDoubleClick={onDoubleClick}
      dangerouslySetInnerHTML={xssChecker}
    />
  ) : (
    <span
      className={`${styles.text} ${
        isFocused ? `${styles.focused}` : "ellipsis"
      }`}
      style={style}
      onDoubleClick={onDoubleClick}
    >
      {value}
    </span>
  );
}

TextComponent.propTypes = {
  value: PropTypes.string,
  style: PropTypes.any,
  onDoubleClick: PropTypes.func,
  isFocused: PropTypes.bool
};

export const Text = memo(TextComponent);
